<template>
  <nav
    :class="[{ [`navbar-${navType}`]: navType }]"
    class="navbar navbar-expand-lg"
  >
    <div class="container-fluid">
      <a :href="$route.fullPath" class="navbar-brand">
        {{ $route.meta.title || $route.name }}
      </a>
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        :aria-expanded="this.$store.state.layout.showSidebar"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >
        <span class="navbar-toggler-bar" />
        <span class="navbar-toggler-bar" />
        <span class="navbar-toggler-bar" />
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>
          <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down> -->
          <!-- <drop-down class="nav-item"
                     title=""
                     title-classes="nav-link"
                     icon="ti-settings">
            <a class="dropdown-item" href="#">Log out</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link" @click="logout">
              <i class="ti-arrow-right"></i>
              <p>Log out</p>
            </a>
          </li> -->
          <li v-if="loggedIn" class="nav-item">
            <RouterLink class="nav-link" :to="{ path: 'notifications' }">
              <i class="fa fa-bell bell" />
            </RouterLink>
          </li>
          <b-nav-item-dropdown v-if="loggedIn" right>
            <!-- Using button-content slot -->
            <template slot="button-content">
              Logged in as
              {{
                $store.state.auth.identity && $store.state.auth.identity.profile
                  ? getDisplayName($store.state.auth.identity.profile)
                  : ''
              }}
            </template>
            <b-dropdown-item v-if="loggedIn" :to="{ name: 'profile' }">
              Profile
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'settings-profile' }">
              Settings
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'logout' }">
              Log out
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <!--
            <NavRoutes :routes="persistentNavRoutes"/>
            <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
            <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
          -->
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { AuthHelpers } from '@paladin/core-auth'
// import NavRoutes from './nav-routes.vue'

export default {
  // components: { NavRoutes },
  props: {
    navType: {
      type: String,
      default: 'default',
      validator: (value) => {
        let acceptedValues = ['default', 'flat']
        return acceptedValues.indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      persistentNavRoutes: [{}],
      loggedInNavRoutes: [
        {
          name: 'profile',
          title: () =>
            'Logged in as ' + this.$store.state.auth.identity &&
            this.$store.state.auth.identity.profile
              ? this.getDisplayName(this.$store.state.auth.identity.profile)
              : '',
        },
        {
          name: 'logout',
          title: 'Log out',
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Log in',
        },
      ],
    }
  },
  computed: {
    ...AuthHelpers.authComputed,
  },
  mounted() {
    // console.log(this.$parent)
    // console.log(this.$route)
  },
  methods: {
    toggleSidebar() {
      // console.log(!this.$store.state.layout.showSidebar)
      this.$store.dispatch(
        'layout/displaySidebar',
        !this.$store.state.layout.showSidebar
      )
    },
    hideSidebar() {
      this.$store.dispatch('layout/displaySidebar', false)
    },
    getDisplayName(profile) {
      if (profile.firstName) return profile.firstName
      if (profile.given_name) return profile.given_name
      if (profile.email) return profile.email
      return ''
    },
  },
}
</script>
